import { defineMessages } from '../translate';

/** Split from `home` so the always-loaded entry chunk carries only these strings. */
export default defineMessages('home-tabs', {
  tabOverview: 'Overview',
  tabTasks: 'My tasks',
  tabAnalytics: 'Analytics',
  tabActivity: 'Activity',
} as const);
